module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid47_960x845.f971467.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid47_960x845.jpg
// module id = SQhu
// module chunks = 0